import { render } from "./HollyHair.vue?vue&type=template&id=2851dda9&scoped=true&lang=pug"
import script from "./HollyHair.vue?vue&type=script&lang=js"
export * from "./HollyHair.vue?vue&type=script&lang=js"

import "./HollyHair.vue?vue&type=style&index=0&id=2851dda9&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2851dda9"]])

export default __exports__